<template>
    <section>

    </section>
</template>

<script>
    export default {
        name: "welcome",
        mounted() {
          this.$router.push('/overview');
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue